module.exports = __webpack_public_path__ + "static/media/precio_especial.c1c393c4.webp";